import { createAction } from '@reduxjs/toolkit';

export const addCart = createAction('app/cart/add');
export const addConfig = createAction('app/addConfig');
